
/**
 * +-------------------------------------------------+
 * |                                                 |
 * | Function Global Untuk Date Utils Alert 2        |
 * +_________________________________________________+
 * 
 * Asalkan function mixin dan vue componentnya sama pagination bisa berjalan
 */

import moment from 'moment';

export const DateUtils = {
    data() {
      return {
        sortCriteria: ""
      };
    },    

    methods: {
      formatDate: function (date, format) {
        return moment(date).format(format);
      },

      alertSuccess() {
        var vm = this;
        const Toast = vm.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
                toast.addEventListener("mouseenter", vm.$swal.stopTimer);
                toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
            }
        });
        Toast.fire({
            icon: "success",
            title: "Data Berhasil Disimpan"
        });
      },
      alertError() {
        this.$swal.fire({
          title: "Peringatan!",
          text: "Data Gagal Disimpan",
          icon: "errorr",
          showCancelButton: true
        });
      },
      alertError(message) {
        this.$swal.fire({
          title: "Peringatan!",
          text: message,
          icon: "errorr",
          showCancelButton: true
        });
      },
    }
  };